import { useEffect, useRef } from 'react';
import { selectLanguage } from './useTranslation';
import { useUIStore } from '@/store/ui';
import { consumePublicLocalePreference } from '@/lib/publicLocalePreference.cjs';

export function usePublicLocalePreference() {
  const attempted = useRef(false);
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const apply = () => {
      if (attempted.current) return;
      attempted.current = true;
      consumePublicLocalePreference(document, selectLanguage, location.protocol === 'https:').catch(() => {});
    };
    if (!useUIStore.persist || useUIStore.persist.hasHydrated()) apply();
    else return useUIStore.persist.onFinishHydration(apply);
  }, []);
}
